import { OnInit, OnDestroy } from '@angular/core';
import { Router } from '@angular/router';
import { Observable } from 'rxjs/Rx';
import { DashboardService } from '../../dashboard';
import { ErrorHandlerService } from '../../services';
import { DashboardPageInboxCountUpdateService } from '../../services';
import { ConfirmationService } from 'primeng/primeng';
var InboxComponent = /** @class */ (function () {
    function InboxComponent(dashboardService, errorHandlerService, dashboardPageInboxCountUpdateService, confirmationService, router) {
        this.dashboardService = dashboardService;
        this.errorHandlerService = errorHandlerService;
        this.dashboardPageInboxCountUpdateService = dashboardPageInboxCountUpdateService;
        this.confirmationService = confirmationService;
        this.router = router;
        this.messageBody = "";
        this.user = {};
        this.rplyMsg = {};
        this.msgreceived = true;
        this.msgsent = false;
        this.reqreceived = false;
        this.rcmdreceived = false;
        this.navigatingFromSentItems = false;
        this.inbox = true;
        this.mymsg = true;
        this.msgSub = '';
        this.rcmdreqSend = { requestTo: {}, requestFrom: {} };
        this.ratereqSend = { requestTo: {}, requestFrom: {} };
        this.writeRcmd = { responseTo: {}, responseFrom: {}, recommendation: {} };
        this.reqwriteRcmd = { responseTo: {}, responseFrom: {}, recommendation: {} };
        this.rating = { responseTo: {}, responseFrom: {}, rating: {} };
        this.compose = {};
        this.userTo = {};
        this.reqRecv = [];
        this.rcmdRecv = [];
        this.reqSent = [];
        this.rcmdreqSent = [];
        this.msgSent = [];
        this.allMsg = [];
        this.usersTo = [];
        this.userToresults = [];
        this.msgdetailsingle = [];
        this.msgdetail = false;
        this.trashData = [];
        this.trashLi = false;
        this.msgTitle = "";
        this.msgContent = "";
        this.popUp = false;
        this.rcmdto = "";
        this.totalNoOfNewNotifications = "";
        this.totalNoOfNewMessagesReceived = "";
        this.totalNoOfNewRequestsReceived = "";
        this.totalNoOfNewRecommendationsReceived = "";
        this.isTotalNoOfNewNotificationsBubbleRequired = true;
        this.isTotalNoOfNewMessagesReceivedBubbleRequired = true;
        this.isTotalNoOfNewRequestsReceivedBubbleRequired = true;
        this.isTotalNoOfNewRecommendationsReceivedBubbleRequired = true;
        this.inboxMsgsLoadMoreCounter = 0;
        this.reqRecvdLoadMoreCounter = 0;
        this.rcmdRecvdLoadMoreCounter = 0;
        this.inboxMsgsSentLoadMoreCounter = 0;
        this.reqSentLoadMoreCounter = 0;
        this.rcmdSentLoadMoreCounter = 0;
        this.showSpinner = false;
        this.showOnlyOverlay = false;
        this.showErrorModalDialog = false;
        this.showErrorMessages = [""];
        this.showErrorMessageTitle = "Error!";
        this.showErrorMessageWidthInPercentage = "20%";
        this.subscriptions = [];
        this.isSessionExpired = false;
        this.showMessagePopupWidthInPercentage = "20%";
        this.showMessageModalDialog = false;
        this.showMessageTitle = "";
        this.showNotificationMessages = [""];
        this.selectedUserMessageContainerId = -1;
    }
    InboxComponent.prototype.editDisplay = function (edit) {
        if (edit) {
            return "block";
        }
        else {
            return "none";
        }
    };
    InboxComponent.prototype.editDisplayInline = function (edit) {
        if (edit) {
            return "inline-block";
        }
        else {
            return "none";
        }
    };
    InboxComponent.prototype.reportSpam = function (id) {
        var _this = this;
        this.confirmationService.confirm({
            message: "<b>Report Spam and Block</b>",
            header: 'Confirmation',
            icon: 'fa fa-question-circle',
            accept: function () {
                _this.showSpinner = true;
                _this.dashboardService.inboxSpam(id).subscribe(function (data) {
                    _this.showSpinner = false;
                    console.log(data);
                }, function (error) {
                    _this.showSpinner = false;
                    _this.handleError(error);
                });
            },
            reject: function () {
                _this.showSpinner = false;
                console.log("User cancelled registration");
            }
        });
    };
    InboxComponent.prototype.inboxAllMsgLoad = function () {
        var _this = this;
        this.showSpinner = true;
        this.messagesReceivedLoadMoreDashboardCountUpdateSubscriber = this.inboxDashboardCountRefresherObservable.subscribe(function (x) {
            _this.updateDashboardCount();
        });
        var s1 = this.dashboardService.inboxAllMsgLoadMore().subscribe(function (data) {
            console.log(data);
            data.forEach(function (element) {
                element.isElementDeleted = false;
            });
            _this.showSpinner = false;
            _this.msgreceived = true;
            data.forEach(function (element) {
                _this.allMsg.push(element);
            });
            ++_this.inboxMsgsLoadMoreCounter;
            _this.showSpinner = false;
        }, function (error) {
            _this.handleError(error);
        });
        this.subscriptions.push(s1);
        this.subscriptions.push(this.messagesReceivedLoadMoreDashboardCountUpdateSubscriber);
    };
    InboxComponent.prototype.rcmdAccept = function (id) {
        var _this = this;
        this.showSpinner = true;
        var s2 = this.dashboardService.rcmdAccept(id).subscribe(function (data) {
            _this.loadRecommendationsReceivedAndMore();
            //this.showSpinner = false;
        }, function (error) {
            _this.handleError(error);
        });
        this.subscriptions.push(s2);
    };
    InboxComponent.prototype.rcmdReject = function (id) {
        var _this = this;
        this.showSpinner = true;
        var s3 = this.dashboardService.rcmdReject(id).subscribe(function (data) {
            _this.loadRecommendationsReceivedAndMore();
            //this.showSpinner = false;
        }, function (error) {
            _this.handleError(error);
        });
        this.subscriptions.push(s3);
    };
    InboxComponent.prototype.reqAccept = function (id) {
        var _this = this;
        this.showSpinner = true;
        var s4 = this.dashboardService.reqAccept(id).subscribe(function (data) {
            _this.loadRequestsReceivedAndMore();
            //this.showSpinner = false;
        }, function (error) {
            _this.handleError(error);
        });
        this.subscriptions.push(s4);
    };
    InboxComponent.prototype.topicreqAccept = function (id) {
        var _this = this;
        this.showSpinner = true;
        var s5 = this.dashboardService.topicreqAccept(id).subscribe(function (data) {
            console.log(data);
            _this.loadRequestsReceivedAndMore();
            //this.showSpinner = false;
        }, function (error) {
            _this.handleError(error);
        });
        this.subscriptions.push(s5);
    };
    InboxComponent.prototype.reqReject = function (id) {
        var _this = this;
        this.showSpinner = true;
        var s6 = this.dashboardService.reqReject(id).subscribe(function (data) {
            _this.loadRequestsReceivedAndMore();
            //this.showSpinner = false;
        }, function (error) {
            _this.handleError(error);
        });
        this.subscriptions.push(s6);
    };
    InboxComponent.prototype.topicreqReject = function (id) {
        var _this = this;
        this.showSpinner = true;
        var s7 = this.dashboardService.topicreqReject(id).subscribe(function (data) {
            _this.loadRequestsReceivedAndMore();
            //this.showSpinner = false;
        }, function (error) {
            _this.handleError(error);
        });
        this.subscriptions.push(s7);
    };
    InboxComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.initFn();
        this.updateDashboardCount();
        this.inboxDashSubscriber = Observable.interval(500 * 60).subscribe(function (x) {
            _this.updateDashboardCount();
        });
        this.inboxDashboardCountRefresherObservable = Observable.interval(500).take(6);
        this.subscriptions.push(this.inboxDashSubscriber);
    };
    InboxComponent.prototype.initFn = function () {
        var _this = this;
        this.showSpinner = true;
        var s8 = this.dashboardService.userSummary1().subscribe(function (data) {
            _this.user = data;
            _this.userDetailsId = _this.user.userDetailsId;
            _this.rcmdreqSend.requestFrom.userDetailsId = _this.user.userDetailsId;
            _this.ratereqSend.requestFrom.userDetailsId = _this.user.userDetailsId;
            _this.writeRcmd.responseFrom.userDetailsId = _this.user.userDetailsId;
            _this.reqwriteRcmd.responseFrom.userDetailsId = _this.user.userDetailsId;
            _this.rating.responseFrom.userDetailsId = _this.user.userDetailsId;
            _this.rplyMsg.senderUserId = _this.user.userDetailsId;
        }, function (error) {
            _this.showSpinner = false;
            _this.handleError(error);
        });
        this.subscriptions.push(s8);
        var s9 = this.dashboardService.inboxAllMsg().subscribe(function (data) {
            console.log(data);
            data.forEach(function (element) {
                element.isElementDeleted = false;
            });
            _this.msgreceived = true;
            _this.allMsg = data;
            _this.showSpinner = false;
        }, function (error) {
            _this.showSpinner = false;
            _this.handleError(error);
        });
        this.subscriptions.push(s9);
    };
    InboxComponent.prototype.backToMessages = function () {
        var _this = this;
        this.showSpinner = true;
        var s90 = this.dashboardService.inboxMsgForContainerId(this.selectedUserMessageContainerId).subscribe(function (data) {
            console.log(data);
            //var counter = 0;
            _this.allMsg.forEach(function (val, ind, arr) {
                if (val.userMessageContainerId == data.userMessageContainerId) {
                    console.log('Match found in position ==>' + ind);
                    console.log(_this.allMsg[ind]);
                    console.log(data);
                    _this.allMsg[ind] = data;
                    _this.allMsg[ind].isElementDeleted = false;
                    console.log('After the replacement');
                    console.log(_this.allMsg[ind]);
                }
                //counter = counter + 1;
            });
            _this.showSpinner = false;
        }, function (error) {
            _this.showSpinner = false;
            _this.handleError(error);
        });
    };
    InboxComponent.prototype.msgRcv = function () {
        var _this = this;
        this.showSpinner = true;
        this.messagesReceivedDashboardCountUpdateSubscriber = this.inboxDashboardCountRefresherObservable.subscribe(function (x) {
            _this.updateDashboardCount();
        });
        var s10 = this.dashboardService.inboxAllMsg().subscribe(function (data) {
            console.log(data);
            data.forEach(function (element) {
                element.isElementDeleted = false;
            });
            _this.msgreceived = true;
            _this.allMsg = data;
            _this.showSpinner = false;
            _this.inboxMsgsLoadMoreCounter = 0;
        }, function (error) {
            _this.showSpinner = false;
            _this.handleError(error);
        });
        this.subscriptions.push(s10);
        this.subscriptions.push(this.messagesReceivedDashboardCountUpdateSubscriber);
    };
    InboxComponent.prototype.deleteFn = function (type, id, element) {
        var _this = this;
        var s11 = this.dashboardService.inboxDelete(type, id).subscribe(function (data) {
            console.log(data);
            if (type == 'reqRec') {
                element.isElementDeleted = true;
                data.forEach(function (element) {
                    element.isElementDeleted = false;
                    element.less = true;
                    _this.reqRecv.push(element);
                });
            }
            if (type == 'msgRec') {
                element.isElementDeleted = true;
                data.forEach(function (element) {
                    _this.allMsg.push(element);
                });
            }
            if (type == 'rcmdRec') {
                element.isElementDeleted = true;
                data.forEach(function (element) {
                    element.isElementDeleted = false;
                    element.less = true;
                    _this.rcmdRecv.push(element);
                });
            }
            if (type == 'msgSent') {
                element.isElementDeleted = true;
                data.forEach(function (element) {
                    element.isElementDeleted = false;
                    element.less = true;
                    _this.msgSent.push(element);
                });
            }
            if (type == 'reqSent') {
                element.isElementDeleted = true;
                data.forEach(function (element) {
                    element.isElementDeleted = false;
                    _this.reqSent.push(element);
                });
            }
            if (type == 'rcmdSent') {
                element.isElementDeleted = true;
                data.forEach(function (element) {
                    element.isElementDeleted = false;
                    element.less = true;
                    _this.rcmdreqSent.push(element);
                });
            }
            if (type == 'trash') {
                element.isElementDeleted = true;
                data.forEach(function (element) {
                    _this.trashData.push(element);
                });
            }
        }, function (error) {
            _this.handleError(error);
        });
        this.subscriptions.push(s11);
    };
    InboxComponent.prototype.searchusers = function (event) {
        var _this = this;
        var s12 = this.dashboardService.myFriendsLookup(event.query).subscribe(function (data) {
            _this.userToresults = data;
            console.log(_this.userToresults);
        }, function (error) {
            _this.handleError(error);
        });
        this.subscriptions.push(s12);
    };
    InboxComponent.prototype.sendRcmdReq = function (form) {
        var _this = this;
        this.showSpinner = true;
        this.rcmdreqSend.userRequestType = 'RECOMMENDATION_REQUEST';
        this.rcmdreqSend.requestFrom.userDetailsId = this.user.userDetailsId;
        this.rcmdreqSend.requestTo.userDetailsId = this.userTo.rcmdreqto.userDetailsId;
        console.log(this.rcmdreqSend);
        var s13 = this.dashboardService.rcmdRequest(this.rcmdreqSend).subscribe(function (data) {
            _this.showSpinner = false;
            form.reset();
            _this.showMessageModalDialog = true;
            _this.showMessageTitle = "Success.";
            _this.showNotificationMessages.push("Recommendaton Request Sent Successfully !!");
            _this.rcmdreqSend = { requestTo: {}, requestFrom: {} };
            _this.userTo.rcmdreqto = [];
        }, function (error) {
            _this.handleError(error);
            _this.showSpinner = false;
            form.reset();
            _this.rcmdreqSend = { requestTo: {}, requestFrom: {} };
            _this.userTo.rcmdreqto = [];
        });
        this.subscriptions.push(s13);
    };
    InboxComponent.prototype.sendRateReq = function (form) {
        var _this = this;
        this.showSpinner = true;
        this.ratereqSend.userRequestType = 'RATING_REQUEST';
        this.ratereqSend.requestFrom.userDetailsId = this.user.userDetailsId;
        this.ratereqSend.requestTo.userDetailsId = this.userTo.ratereqto.userDetailsId;
        console.log(this.ratereqSend);
        var s14 = this.dashboardService.rateRequest(this.ratereqSend).subscribe(function (data) {
            _this.showSpinner = false;
            form.reset();
            _this.showMessageModalDialog = true;
            _this.showMessageTitle = "Success.";
            _this.showNotificationMessages.push("Rating Request Sent Successfully !!");
            _this.ratereqSend = { requestTo: {}, requestFrom: {} };
        }, function (error) {
            _this.handleError(error);
            _this.showSpinner = false;
            form.reset();
            _this.ratereqSend = { requestTo: {}, requestFrom: {} };
        });
        this.subscriptions.push(s14);
    };
    InboxComponent.prototype.writeRcmdSend = function (form) {
        var _this = this;
        this.showSpinner = true;
        this.writeRcmd.userResponseType = 'RECOMMENDATION_RESPONSE';
        this.writeRcmd.responseFrom.userDetailsId = this.user.userDetailsId;
        this.writeRcmd.responseTo.userDetailsId = this.userTo.writeRcmdto.userDetailsId;
        console.log(this.writeRcmd);
        var s15 = this.dashboardService.inboxrcmdRequest(this.writeRcmd).subscribe(function (data) {
            if (data) {
                _this.showSpinner = false;
                form.reset();
                _this.showMessageModalDialog = true;
                _this.showMessageTitle = "Success.";
                _this.showNotificationMessages.push("Recommendaton Sent Successfully !!");
                _this.writeRcmd = { responseTo: {}, recommendation: {}, responseFrom: {} };
            }
        }, function (error) {
            _this.handleError(error);
            _this.showSpinner = false;
            form.reset();
            _this.writeRcmd = { responseTo: {}, recommendation: {}, responseFrom: {} };
        });
        this.subscriptions.push(s15);
    };
    InboxComponent.prototype.ratingUser = function (id, form) {
        var _this = this;
        this.showSpinner = true;
        this.rating.responseTo.userDetailsId = id;
        this.rating.responseFrom.userDetailsId = this.user.userDetailsId;
        this.rating.userResponseType = 'RATING_RESPONSE';
        console.log(this.rating);
        var s16 = this.dashboardService.rating(this.rating).subscribe(function (data) {
            _this.showSpinner = false;
            _this.showMessageModalDialog = true;
            _this.showMessageTitle = "Success.";
            _this.showNotificationMessages.push("Rating Sent Successfully !!");
            form.reset();
            _this.rating = { responseTo: {}, responseFrom: {} };
        }, function (error) {
            _this.handleError(error);
            _this.showSpinner = false;
            form.reset();
            _this.rating = { responseTo: {}, responseFrom: {} };
        });
        this.subscriptions.push(s16);
    };
    InboxComponent.prototype.reqrecrcmd = function (show, id, form) {
        var _this = this;
        this.showSpinner = true;
        this.reqwriteRcmd.userResponseType = 'RECOMMENDATION_RESPONSE';
        this.reqwriteRcmd.responseFrom.userDetailsId = this.user.userDetailsId;
        this.reqwriteRcmd.responseTo.userDetailsId = id;
        console.log(this.reqwriteRcmd);
        var s17 = this.dashboardService.inboxrcmdRequest(this.reqwriteRcmd).subscribe(function (data) {
            show.show = false;
            _this.showSpinner = false;
            _this.showMessageModalDialog = true;
            _this.showMessageTitle = "Success.";
            _this.showNotificationMessages.push("Recommendaton Sent Successfully !!");
            //form.reset();
            _this.reqwriteRcmd = { responseTo: {}, responseFrom: {}, recommendation: {} };
        }, function (error) {
            _this.handleError(error);
            _this.showSpinner = false;
            show.show = false;
            //form.reset();
            _this.reqwriteRcmd = { responseTo: {}, responseFrom: {}, recommendation: {} };
        });
        this.subscriptions.push(s17);
    };
    InboxComponent.prototype.sendMessage = function (form) {
        var _this = this;
        this.showSpinner = true;
        var arrTo = [];
        this.userTo.messageto.forEach(function (element) {
            arrTo.push(element.userDetailsId);
        });
        this.compose.usersInTo = arrTo;
        var s18 = this.dashboardService.inboxSendMsg(this.compose).subscribe(function (data) {
            console.log(data);
            form.reset();
            _this.showMessageModalDialog = true;
            _this.showMessageTitle = "Success.";
            _this.showNotificationMessages.push("Message Sent Successfully !!");
            _this.compose = {};
            _this.userTo.messageto = [];
            _this.showSpinner = false;
        }, function (error) {
            _this.handleError(error);
            _this.compose = {};
            _this.userTo.messageto = [];
            _this.showSpinner = false;
        });
        this.subscriptions.push(s18);
    };
    InboxComponent.prototype.reqRcv = function () {
        var _this = this;
        this.showSpinner = true;
        this.requestsReceivedDashboardCountUpdateSubscriber = this.inboxDashboardCountRefresherObservable.subscribe(function (x) {
            _this.updateDashboardCount();
        });
        var s19 = this.dashboardService.inboxReqRecv().subscribe(function (data) {
            data.forEach(function (element) {
                element.isElementDeleted = false;
                element.less = true;
            });
            _this.reqRecv = data;
            console.log(_this.reqRecv);
            _this.showSpinner = false;
            _this.reqRecvdLoadMoreCounter = 0;
            console.log("The value of reqRecvdLoadMoreCounter==>" + _this.reqRecvdLoadMoreCounter);
        }, function (error) {
            _this.handleError(error);
            _this.showSpinner = false;
        });
        this.subscriptions.push(s19);
        this.subscriptions.push(this.requestsReceivedDashboardCountUpdateSubscriber);
    };
    InboxComponent.prototype.rcmdRcv = function () {
        var _this = this;
        this.showSpinner = true;
        this.recommendationsReceivedDashboardCountUpdateSubscriber = this.inboxDashboardCountRefresherObservable.subscribe(function (x) {
            _this.updateDashboardCount();
        });
        var s20 = this.dashboardService.inboxRcmdRecv().subscribe(function (data) {
            data.forEach(function (element) {
                element.isElementDeleted = false;
                element.less = true;
            });
            _this.rcmdRecv = data;
            console.log(_this.rcmdRecv);
            _this.showSpinner = false;
            _this.rcmdRecvdLoadMoreCounter = 0;
        }, function (error) {
            _this.handleError(error);
            _this.showSpinner = false;
        });
        this.subscriptions.push(s20);
        this.subscriptions.push(this.recommendationsReceivedDashboardCountUpdateSubscriber);
    };
    InboxComponent.prototype.reqRcvMore = function () {
        var _this = this;
        this.showSpinner = true;
        this.requestsReceivedLoadMoreDashboardCountUpdateSubscriber = this.inboxDashboardCountRefresherObservable.subscribe(function (x) {
            _this.updateDashboardCount();
        });
        var s22 = this.dashboardService.inboxReqRecvloadmore().subscribe(function (data) {
            data.forEach(function (element) {
                element.isElementDeleted = false;
                element.less = true;
                _this.reqRecv.push(element);
            });
            ++_this.reqRecvdLoadMoreCounter;
            console.log("The value of reqRecvdLoadMoreCounter after loading more==>" + _this.reqRecvdLoadMoreCounter);
            _this.showSpinner = false;
        }, function (error) {
            _this.handleError(error);
            _this.showSpinner = false;
        });
        this.subscriptions.push(s22);
        this.subscriptions.push(this.requestsReceivedLoadMoreDashboardCountUpdateSubscriber);
    };
    InboxComponent.prototype.rcmdRcvLoadMore = function () {
        var _this = this;
        this.showSpinner = true;
        this.recommendationsReceivedLoadMoreDashboardCountUpdateSubscriber = this.inboxDashboardCountRefresherObservable.subscribe(function (x) {
            _this.updateDashboardCount();
        });
        var s21 = this.dashboardService.inboxRcmdRecvLoadMore().subscribe(function (data) {
            data.forEach(function (element) {
                element.isElementDeleted = false;
                element.less = true;
                _this.rcmdRecv.push(element);
            });
            ++_this.rcmdRecvdLoadMoreCounter;
            _this.showSpinner = false;
        }, function (error) {
            _this.handleError(error);
            _this.showSpinner = false;
        });
        this.subscriptions.push(s21);
        this.subscriptions.push(this.recommendationsReceivedLoadMoreDashboardCountUpdateSubscriber);
    };
    InboxComponent.prototype.messageSent = function () {
        var _this = this;
        this.showSpinner = true;
        var s23 = this.dashboardService.inboxMessageSent().subscribe(function (data) {
            data.forEach(function (element) {
                element.isElementDeleted = false;
                element.less = true;
            });
            _this.msgSent = data;
            console.log(_this.msgSent);
            _this.showSpinner = false;
        }, function (error) {
            _this.handleError(error);
            _this.showSpinner = false;
        });
        this.subscriptions.push(s23);
    };
    InboxComponent.prototype.requestsent = function () {
        var _this = this;
        this.showSpinner = true;
        var s24 = this.dashboardService.inboxReqSent().subscribe(function (data) {
            data.forEach(function (element) {
                element.isElementDeleted = false;
            });
            _this.reqSent = data;
            _this.showSpinner = false;
        }, function (error) {
            _this.handleError(error);
            _this.showSpinner = false;
        });
        this.subscriptions.push(s24);
    };
    InboxComponent.prototype.rcmdrespsent = function () {
        var _this = this;
        this.showSpinner = true;
        var s25 = this.dashboardService.inboxRcmdRespSent().subscribe(function (data) {
            data.forEach(function (element) {
                element.isElementDeleted = false;
                element.less = true;
            });
            _this.rcmdreqSent = data;
            _this.showSpinner = false;
        }, function (error) {
            _this.handleError(error);
            _this.showSpinner = false;
        });
        this.subscriptions.push(s25);
    };
    InboxComponent.prototype.messageSentLoadMore = function () {
        var _this = this;
        this.showSpinner = true;
        var s35 = this.dashboardService.inboxMessageSentLoadMore().subscribe(function (data) {
            data.forEach(function (element) {
                element.isElementDeleted = false;
                element.less = true;
                _this.msgSent.push(element);
            });
            console.log(_this.msgSent);
            _this.showSpinner = false;
        }, function (error) {
            _this.handleError(error);
            _this.showSpinner = false;
        });
        this.subscriptions.push(s35);
    };
    InboxComponent.prototype.requestsentLoadMore = function () {
        var _this = this;
        this.showSpinner = true;
        var s36 = this.dashboardService.inboxReqSentLoadMore().subscribe(function (data) {
            data.forEach(function (element) {
                element.isElementDeleted = false;
                _this.reqSent.push(element);
            });
            _this.showSpinner = false;
        }, function (error) {
            _this.handleError(error);
            _this.showSpinner = false;
        });
        this.subscriptions.push(s36);
    };
    InboxComponent.prototype.rcmdrespsentLoadMore = function () {
        var _this = this;
        this.showSpinner = true;
        var s37 = this.dashboardService.inboxRcmdRespSentLoadMore().subscribe(function (data) {
            data.forEach(function (element) {
                element.isElementDeleted = false;
                element.less = true;
                _this.rcmdreqSent.push(element);
            });
            _this.showSpinner = false;
        }, function (error) {
            _this.handleError(error);
            _this.showSpinner = false;
        });
        this.subscriptions.push(s37);
    };
    InboxComponent.prototype.restoreFn = function (id) {
        var _this = this;
        this.showSpinner = true;
        var s26 = this.dashboardService.inboxTrashRestore(id).subscribe(function (data) {
            _this.trash();
            console.log(data);
            _this.showSpinner = false;
        }, function (error) {
            _this.handleError(error);
            _this.showSpinner = false;
        });
        this.subscriptions.push(s26);
    };
    InboxComponent.prototype.trash = function () {
        var _this = this;
        this.showSpinner = true;
        var s27 = this.dashboardService.inboxTrash().subscribe(function (data) {
            data.forEach(function (element) {
                element.isElementDeleted = false;
            });
            _this.trashData = data;
            console.log(_this.trashData);
            _this.showSpinner = false;
        }, function (error) {
            _this.handleError(error);
            _this.showSpinner = false;
        });
        this.subscriptions.push(s27);
    };
    InboxComponent.prototype.trashLoad = function () {
        var _this = this;
        this.showSpinner = true;
        var s28 = this.dashboardService.inboxTrashloadmore().subscribe(function (data) {
            data.forEach(function (element) {
                _this.trashData.push(element);
            });
            _this.showSpinner = false;
        }, function (error) {
            _this.handleError(error);
            _this.showSpinner = false;
        });
        this.subscriptions.push(s28);
    };
    InboxComponent.prototype.msgClick = function (id) {
        var _this = this;
        this.selectedUserMessageContainerId = id;
        this.msgdetailsingle = [];
        this.showSpinner = true;
        this.msgdetail = true;
        this.msgreceived = false;
        this.navigatingFromSentItems = false;
        var s29 = this.dashboardService.inboxMsgCon(id).subscribe(function (data) {
            var temp_arr = data;
            data.forEach(function (val, ind, arr) {
                _this.msgSub = val.messageSubject;
                temp_arr[ind].reply = true;
                temp_arr[ind].replybox = false;
                temp_arr[ind].containerId = id;
            });
            _this.msgdetailsingle = temp_arr;
            console.log(_this.msgdetailsingle);
            _this.showSpinner = false;
        }, function (error) {
            _this.handleError(error);
            _this.showSpinner = false;
        });
        this.subscriptions.push(s29);
    };
    InboxComponent.prototype.msgClickSentItems = function (id) {
        var _this = this;
        this.msgdetailsingle = [];
        this.showSpinner = true;
        this.msgdetail = true;
        this.msgsent = false;
        this.navigatingFromSentItems = true;
        var s29 = this.dashboardService.inboxMsgCon(id).subscribe(function (data) {
            var temp_arr = data;
            data.forEach(function (val, ind, arr) {
                _this.msgSub = val.messageSubject;
                temp_arr[ind].reply = true;
                temp_arr[ind].replybox = false;
                temp_arr[ind].containerId = id;
            });
            _this.msgdetailsingle = temp_arr;
            console.log(_this.msgdetailsingle);
            _this.showSpinner = false;
        }, function (error) {
            _this.handleError(error);
            _this.showSpinner = false;
        });
        this.subscriptions.push(s29);
    };
    InboxComponent.prototype.replyToMesg = function (msgdata) {
        var _this = this;
        console.log(msgdata);
        this.showSpinner = true;
        this.msgdetail = true;
        this.msgreceived = false;
        this.rplyMsg.messageThread = msgdata.messageThread;
        this.rplyMsg.messageSubject = msgdata.messageSubject;
        this.rplyMsg.usersInTo = [msgdata.senderUserId];
        this.rplyMsg.htmlFormattedMessageBody = msgdata.htmlFormattedMessageBody;
        this.rplyMsg.isMessageBodyHTMLFormatted = msgdata.isMessageBodyHTMLFormatted;
        this.rplyMsg.messageBody = this.messageBody;
        var s30 = this.dashboardService.replyToMsg(this.rplyMsg).subscribe(function (data) {
            // //this.msgdetailsingle = data;
            // console.log(data);
            // this.msgRcv();
            _this.messageBody = "";
            // this.showSpinner = false;
            // this.msgdetail = false;
            _this.msgClick(msgdata.containerId);
        }, function (error) {
            _this.handleError(error);
            _this.showSpinner = false;
        });
        this.subscriptions.push(s30);
    };
    InboxComponent.prototype.loadMessagesReceivedAndMore = function () {
        var _this = this;
        var counter = this.inboxMsgsLoadMoreCounter;
        var checkCounter = this.inboxMsgsLoadMoreCounter;
        console.log("Messages received Load More Counter at outset:" + counter);
        this.showSpinner = true;
        var s101 = this.dashboardService.inboxAllMsg().subscribe(function (data) {
            console.log(data);
            data.forEach(function (element) {
                element.isElementDeleted = false;
            });
            _this.msgreceived = true;
            _this.allMsg = data;
            _this.inboxMsgsLoadMoreCounter = 0;
            if (counter == 0) {
                _this.showSpinner = false;
            }
            while (counter > 0) {
                console.log("Messages received Load More Counter inside loop:" + counter);
                var s111 = _this.dashboardService.inboxAllMsgLoadMore().subscribe(function (data) {
                    //console.log(data);
                    data.forEach(function (element) {
                        element.isElementDeleted = false;
                    });
                    _this.msgreceived = true;
                    data.forEach(function (element) {
                        _this.allMsg.push(element);
                    });
                    ++_this.inboxMsgsLoadMoreCounter;
                    if (checkCounter == _this.inboxMsgsLoadMoreCounter) {
                        _this.showSpinner = false;
                    }
                }, function (error) {
                    _this.handleError(error);
                });
                _this.subscriptions.push(s111);
                --counter;
            }
        }, function (error) {
            _this.showSpinner = false;
            _this.handleError(error);
        });
        this.subscriptions.push(s101);
        console.log("Messages received Load More Counter in the end:" + counter);
    };
    InboxComponent.prototype.loadRequestsReceivedAndMore = function () {
        var _this = this;
        console.log("The value of reqRecvdLoadMoreCounter inside loadRequestsReceivedAndMore==>" + this.reqRecvdLoadMoreCounter);
        var counter = this.reqRecvdLoadMoreCounter;
        var checkCounter = this.reqRecvdLoadMoreCounter;
        console.log("The value of counter inside loadRequestsReceivedAndMore==>" + counter);
        console.log("Requests received Load More Counter at outset:" + counter);
        this.showSpinner = true;
        var s191 = this.dashboardService.inboxReqRecv().subscribe(function (data) {
            data.forEach(function (element) {
                element.isElementDeleted = false;
                element.less = true;
            });
            _this.reqRecv = data;
            console.log(_this.reqRecv);
            _this.reqRecvdLoadMoreCounter = 0;
            console.log("The value of reqRecvdLoadMoreCounter==>" + _this.reqRecvdLoadMoreCounter);
            if (counter == 0) {
                _this.showSpinner = false;
            }
            while (counter > 0) {
                console.log("Requests received Load More Counter inside loop:" + counter);
                var s221 = _this.dashboardService.inboxReqRecvloadmore().subscribe(function (data) {
                    data.forEach(function (element) {
                        element.isElementDeleted = false;
                        element.less = true;
                        _this.reqRecv.push(element);
                    });
                    ++_this.reqRecvdLoadMoreCounter;
                    console.log("The checcounter=" + checkCounter + " and showspinner = " + _this.showSpinner);
                    if (checkCounter == _this.reqRecvdLoadMoreCounter) {
                        _this.showSpinner = false;
                    }
                    console.log("The value of reqRecvdLoadMoreCounter after loading more==>" + _this.reqRecvdLoadMoreCounter);
                }, function (error) {
                    _this.handleError(error);
                    _this.showSpinner = false;
                });
                _this.subscriptions.push(s221);
                --counter;
            }
            console.log("Requests received Load More Counter in the end:" + counter);
        }, function (error) {
            _this.handleError(error);
            _this.showSpinner = false;
        });
        this.subscriptions.push(s191);
        this.subscriptions.push(this.requestsReceivedDashboardCountUpdateSubscriber);
    };
    InboxComponent.prototype.loadRecommendationsReceivedAndMore = function () {
        var _this = this;
        var counter = this.rcmdRecvdLoadMoreCounter;
        var checkCounter = this.rcmdRecvdLoadMoreCounter;
        console.log("Recommendations received Load More Counter at outset:" + counter);
        this.showSpinner = true;
        var s201 = this.dashboardService.inboxRcmdRecv().subscribe(function (data) {
            data.forEach(function (element) {
                element.isElementDeleted = false;
                element.less = true;
            });
            _this.rcmdRecv = data;
            _this.rcmdRecvdLoadMoreCounter = 0;
            if (counter == 0) {
                _this.showSpinner = false;
            }
            while (counter > 0) {
                console.log("Recommendations received Load More Counter inside loop:" + counter);
                var s211 = _this.dashboardService.inboxRcmdRecvLoadMore().subscribe(function (data) {
                    data.forEach(function (element) {
                        element.isElementDeleted = false;
                        element.less = true;
                        _this.rcmdRecv.push(element);
                    });
                    ++_this.rcmdRecvdLoadMoreCounter;
                    if (checkCounter == _this.rcmdRecvdLoadMoreCounter) {
                        _this.showSpinner = false;
                    }
                }, function (error) {
                    _this.handleError(error);
                    _this.showSpinner = false;
                });
                _this.subscriptions.push(s211);
                --counter;
            }
        }, function (error) {
            _this.handleError(error);
            _this.showSpinner = false;
        });
        this.subscriptions.push(s201);
        console.log("Recommendations received Load More Counter inside loop:" + counter);
    };
    InboxComponent.prototype.updateDashboardCount = function () {
        var _this = this;
        var s31 = this.dashboardService.loggedInUser().subscribe(function (data) {
            var currentTotalNoOfNewMessagesReceived = Number(_this.totalNoOfNewMessagesReceived);
            var currentTotalNoOfNewRequestsReceived = Number(_this.totalNoOfNewRequestsReceived);
            var currentTotalNoOfNewRecommendationsReceived = Number(_this.totalNoOfNewRecommendationsReceived);
            _this.totalNoOfNewNotifications = data.totalNoOfNewNotifications;
            _this.totalNoOfNewMessagesReceived = data.noOfNewMessages;
            _this.totalNoOfNewRequestsReceived = data.totalNoOfNewRequestsReceived;
            _this.totalNoOfNewRecommendationsReceived = data.noOfNewRecommendationsReceived;
            if (_this.totalNoOfNewNotifications == '0') {
                _this.isTotalNoOfNewNotificationsBubbleRequired = false;
            }
            else {
                _this.isTotalNoOfNewNotificationsBubbleRequired = true;
            }
            if (_this.totalNoOfNewMessagesReceived == '0') {
                _this.isTotalNoOfNewMessagesReceivedBubbleRequired = false;
            }
            else {
                _this.isTotalNoOfNewMessagesReceivedBubbleRequired = true;
            }
            if (_this.totalNoOfNewRequestsReceived == '0') {
                _this.isTotalNoOfNewRequestsReceivedBubbleRequired = false;
            }
            else {
                _this.isTotalNoOfNewRequestsReceivedBubbleRequired = true;
            }
            if (_this.totalNoOfNewRecommendationsReceived == '0') {
                _this.isTotalNoOfNewRecommendationsReceivedBubbleRequired = false;
            }
            else {
                _this.isTotalNoOfNewRecommendationsReceivedBubbleRequired = true;
            }
            // if noOfNewMessages has increased refresh the page
            if (Number(_this.totalNoOfNewMessagesReceived) > currentTotalNoOfNewMessagesReceived
                && _this.inboxMsgsLoadMoreCounter == 0 && _this.msgreceived == true) {
                _this.msgRcv();
            }
            // if totalNoOfNewRequestsReceived has increased refresh the page
            if (Number(_this.totalNoOfNewRequestsReceived) > currentTotalNoOfNewRequestsReceived
                && _this.reqRecvdLoadMoreCounter == 0 && _this.reqreceived == true) {
                _this.reqRcv();
            }
            // if totalNoOfNewRecommendationsReceived has increased refresh the page.
            if (Number(_this.totalNoOfNewRecommendationsReceived) > currentTotalNoOfNewRecommendationsReceived
                && _this.rcmdRecvdLoadMoreCounter == 0 && _this.rcmdreceived == true) {
                _this.rcmdRcv();
            }
            _this.dashboardPageInboxCountUpdateService.updateInboxCount(data);
            console.log("this.totalNoOfNewNotifications, this.totalNoOfNewMessagesReceived,	this.totalNoOfNewRequestsReceived, this.totalNoOfNewRecommendationsReceived" + _this.totalNoOfNewNotifications + "," + _this.totalNoOfNewMessagesReceived + "," + _this.totalNoOfNewRequestsReceived + "," + _this.totalNoOfNewRecommendationsReceived);
        }, function (error) {
            _this.handleError(error);
        });
        this.subscriptions.push(s31);
    };
    InboxComponent.prototype.ngOnDestroy = function () {
        this.inboxDashSubscriber.unsubscribe();
        this.subscriptions.forEach(function (element) {
            element.unsubscribe();
        });
    };
    InboxComponent.prototype.closeMessagePopup = function () {
        console.log("After closing Error Popup");
        // Trying to access whose account has been deleted.
        console.log("Session did not expire, will remove the overlay");
        this.showSpinner = false;
        this.showOnlyOverlay = false;
        this.showMessageModalDialog = false;
        this.showNotificationMessages = [];
    };
    InboxComponent.prototype.handleError = function (error) {
        this.showSpinner = false;
        console.log("The error inside the Error Handler==>" + error);
        var url = error.url;
        console.log("The URL of the error==>" + error.url);
        if (url == undefined) {
            return;
        }
        console.log("Throwing the error now. Shall call the errorHandlerService throwError method");
        this.errorHandlerService.throwError(error);
    };
    return InboxComponent;
}());
export { InboxComponent };
//# sourceMappingURL=inbox.component.js.map